/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  baseURL: 'https://test-pheno-api.anuvabio.io/api/v1/',
  cronURL: 'https://test-pheno-cron.anuvabio.io/api/v1/',

};
